var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInfinity = function SvgInfinity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 28,
    viewBox: "0 0 51 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 14.44C51 5.76 45.72 0.8 39.32 0.8C33.56 0.8 29.76 4.16 25.92 10.56C21.8 4.32 18.2 0.8 12.12 0.8C5.52 0.8 0.2 5.84 0.2 14.32C0.2 22.96 5.48 28 11.92 28C17.68 28 21.48 24.64 25.32 18.24C29.44 24.44 33.04 28 39.12 28C45.68 28 51 22.92 51 14.44ZM39.12 6.12C43.12 6.12 46.4 9.16 46.4 14.44C46.4 19.64 43.12 22.68 39.16 22.68C34.72 22.68 31.76 19.56 28.2 14.08C31.68 8.64 34.92 6.12 39.12 6.12ZM4.8 14.32C4.8 9.08 8.08 6.12 12.04 6.12C16.48 6.12 19.48 9.2 23.04 14.72C19.56 20.12 16.28 22.68 12.08 22.68C8.08 22.68 4.8 19.56 4.8 14.32Z",
    fill: "#1A181A"
  })));
};
export default SvgInfinity;